<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：首页图表
    -->
	<div class="echart">
		<div>
			<el-input placeholder="请输入内容" v-model="years" class="input-with-select" style="width:150px;margin-bottom:10px;" disabled>
				<el-button slot="prepend" :disabled="buttons != 0" @click="onYear(0)"><i class="el-icon-arrow-left"></i></el-button>
				<el-button slot="append"  :disabled="buttons != 1" @click="onYear(1)"><i class="el-icon-arrow-right"></i></el-button>
			</el-input>
		</div>
		<div id="myChart" class="myChart" :style="pieStyle"></div>
		<div id="myCharts" class="myCharts" :style="barStyle"></div>
	</div>

</template>

<script>
	// 引入基本模板
	let echarts = require('echarts/lib/echarts')
	// 引入柱状图组件
	require('echarts/lib/chart/bar')
	require('echarts/lib/chart/pie');
	// 引入提示框和title组件
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	require('echarts/lib/component/markPoint');
	require('echarts/lib/component/markLine');
	require('echarts/lib/component/legendScroll');
	export default {
		name: 'index',
		data() {
			return {
				years: "2019",
				buttons: 0,
				pieStyle: {	
					width: '500px',
					height: '300px',
				},
				barStyle: {
					width: '1600px',
					height: '500px',
				},
				pieList:[],
				barList:[],
			}
		},
		mounted: function() {
			this.inits();
		},
		methods: {
			inits(){
				let dates = new Date();
				this.years = dates.getFullYear().toString();
				this.drawLine(this.years);
				this.barData(this.years);
			},
			drawLine(years) {
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById('myChart'))
				var colors = ['#FD1B12','#1586cc','#23BDC5','#13CA18','#841AC5','#C61968','#CA831B','#C61968']
				var formatter = function (value, index) {} 
				// 绘制图表
				myChart.setOption({
					title: {
						text:'小区用电量比例'
					},
					tooltip: {
						trigger: 'item',
						formatter: ""
					},
					color:colors,
					series: []
				});
				this.$jssdk.count.homePage({year: years},(data)=>{
					console.log("data:",data)
	               	var addPieData = new Array();
		                myChart.setOption({
		                	tooltip: {
								trigger: 'item',
								formatter:function(params, ticket, callback){
									return '地址：'+params.name + '<br />年份：' + params.data.year + '<br />用电量：' + params.value +'<br/>总电表数：'+params.data.nub 
								}
							},
							series:[{
									name: '访问来源',
									type: 'pie',
									radius: '55%',
									data: data.BList,
									itemStyle: {
										emphasis: {
											shadowBlur: 10,
											shadowOffsetX: 0,
											shadowColor: 'rgba(0, 0, 0, 0.5)'
										},
										normal:{
											opacity:0.7
										},
									}
							}]
		                })
				})
			},
			barData(years) {
				let myCharts = echarts.init(document.getElementById('myCharts'))
				var colors = ['#FD1B12','#1586cc','#23BDC5','#13CA18','#841AC5','#C61968','#CA831B','#C61968']
				myCharts.setOption({
					title: {
						text: '小区月用电量走势',
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ''
					},
					color:colors,
					toolbox: {
						show: true,
						
					},
					xAxis: [{
						type: 'category',
						data: []
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [
					{
						name:'',
						type:'bar',
						data:[],
		              },
						 
				]
				})
				this.$jssdk.count.homePage({year: years},(data)=>{
				var dataData= new Array();
               	var addData = new Array(); 
               	var xList = ''
                for(var i=0;i<data.ZList.length;i++)   
	                {  
	                	var xList = data.ZList[i].month
	                	addData.push(data.ZList[i].name)
	                	dataData.push(eval('(' + ("{'name':'"+data.ZList[i].name+"','type':'bar','data':["+data.ZList[i].date+"],'markPoint':{'data':[{'type':'max','name':'最大值'},{'type':'min','name':'最小值'}]},'markLine':{'data':[{'type':'average','name':'平均值'}]}}") + ')')); 
	                	console.log(dataData)
	                } 
					myCharts.setOption({
						xAxis:[{
							data:xList
						}],
						legend: {
							data:addData
						},
						series:dataData,
		                markLine: {
		                  data: [{
		                    type: 'average',
		                    name: '平均值'
		                  }]
		                }
						
					})
				})
			},
			onYear(onis) {
				if(onis == 0){
					-- this.years;
					this.buttons = 1;
				} else {
					++ this.years;
					this.buttons = 0;
				}
				this.drawLine(this.years);
				this.barData(this.years);
			}
		},
	}
</script>

<style>
	.myChart {
		margin: 0;
		padding: 0;
	}
	
	.myCharts {
		margin: 0;
		padding: 0;
	}
	@media only screen and (max-width:1400px ) {
		.myCharts {
			width: 1000px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// Index.vue?7fe8456d